import permissionCheck from '@/util/ACL/permissionCheck';
import store from '@/store.js'
import roleCheck from '@/util/ACL/permissionCheck';
import permissions from '@/util/ACL/permissionMap';
import modelPermissionCheck from '@/util/ACL/modelPermissionCheck';

export default  {
  name: 'isGrantedModel',
  methods: {
    isGranted(permission, model){
      let hasPermission = false;
      let user = store.state.user;

      if (user.isAdmin) {
        hasPermission = true;
      } else {
        if (permission) {

          hasPermission = modelPermissionCheck(permission, model)
        }
        // Check permissions on client
        if (!hasPermission && permissionCheck(permission)){
          hasPermission = true;
          return true;
        }
      }

      return hasPermission;
    }
  }
}
